import { render, staticRenderFns } from "./result.vue?vue&type=template&id=18d93bae&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"
import style0 from "./result.vue?vue&type=style&index=0&id=18d93bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d93bae",
  null
  
)

export default component.exports